// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3VyMy","tags":"Card_tags__3ROd-","tag":"Card_tag__1txf0","readMore":"Card_readMore__1295y","minutesRead":"Card_minutesRead__t622k","btn":"Card_btn__2VzF0"};